export const LEFT_COL_WIDTH = '55px';
export const RIGHT_COL_WIDTH = '55px';
export const PROGRESS_BAR_OFFSET = '8px';
export const PROGRESS_BAR_HEIGHT = '4px';
export const PROGRESS_BAR_BORDER_RADIUS = '100';